<div
  id="label_select_{{ inId }}"
  [formGroup]="group"
  class="form-group carm-form-group"
  [ngClass]="inClass"
>
  <div *ngIf="!inDisplayControlOnly && labelPlacement === 'above' && inLabel">
    <label *ngIf="inLabel" [for]="inId" [ngClass]="{ required: isRequired }">
      <span class="field-name">{{ inLabel }}</span>
      <strong *ngIf="isRequired" class="required carm-required mrgn-lft-sm"
        >({{ 'form.required' | translate }})</strong
      >
      <ng-content select="[help]"></ng-content>
    </label>
  </div>
  <ng-template
    *ngIf="errorPlacement === 'top'"
    [ngTemplateOutlet]="errorContent"
  ></ng-template>
  <div class="left-label-input-container">
    <div
      class="left-label-container"
      *ngIf="!inDisplayControlOnly && labelPlacement === 'left' && inLabel"
    >
      <label *ngIf="inLabel" [for]="inId" [class.required]="isRequired">
        <span class="field-name nowrap">{{ inLabel }}</span>
        <strong *ngIf="isRequired" class="required carm-required mrgn-lft-sm"
          >({{ 'form.required' | translate }})</strong
        >
        <ng-content></ng-content>
      </label>
    </div>
    
    <div class="extra-input-info" [class.fit-to-size]="fitToSize">
      <div class="input-wrapper">
        <!-- Confirmed returns selected value as a complete object -->
          <select
          *ngIf="inValueClass"
          [compareWith]="compareFn"
          [formControl]="formControl"
          id="{{ inId }}"
          [attr.data-cy]="inDataCy || inId"
          class="form-control carm-select menulist-button {{
            inDisplayControlOnly && inLabel ? 'test_' + inLabel : null
          }}"
          [class.fit-to-size]="fitToSize"
          [attr.aria-label]="inDisplayControlOnly && inLabel ? inLabel : null"
          (change)="onItemChange($event)"
        >
          <option
            *ngIf="inOptionMsg"
            class="{{ inOptionClass }}"
            [ngValue]="null"
          >
            {{ inOptionMsg }}
          </option>
          <option
            class="{{ inOptionClass }} {{ 'test_' + option.key }}"
            *ngFor="let option of inOptions trackBy: trackByFn"
            [ngValue]="option"
            disabled="{{ option?.disabled ? 'disabled' : '' }}"
          >
            {{ option.value }}
          </option>
        </select>
        <!-- returns selected value as an object key -->
        <select
          *ngIf="!inValueClass"
          [formControl]="formControl"
          id="{{ inId }}"
          [attr.data-cy]="inDataCy || inId"
          class="form-control carm-select menulist-button {{
            inDisplayControlOnly && inLabel ? 'test_' + inLabel : null
          }}"
          [class.fit-to-size]="fitToSize"
          [attr.disabled]="inDisabled ? true : null"
          [attr.aria-label]="inDisplayControlOnly && inLabel ? inLabel : null"
          (change)="onItemChange($event)"
        >
          <optgroup
            disabled="disabled"
            class="opt-group"
            *ngIf="!isEdge"
          ></optgroup>
          <option
            *ngIf="inOptionMsg"
            class="{{ inOptionClass }}"
            [ngValue]="null"
          >
            {{ inOptionMsg }}
          </option>
          <option
            *ngIf="!inOptionMsg && !group.value[controlName]"
            [ngValue]="null"
            selected disabled
          ></option>
          <ng-container *ngFor="let option of inOptions trackBy: trackByFn">
            <option
              *ngIf="option.key === null"
              class="{{ inOptionClass }} {{ 'test_' + option.key }}"
              [ngValue]="null"
            >
              {{ inOptionMsg }}
            </option>
            <option
              *ngIf="option.key !== null"
              class="{{ inOptionClass }} {{ 'test_' + option.key }}"
              [value]="option.key"
            >
              {{ option.value }}
            </option>
          </ng-container>
        </select>
        <ng-template
          *ngIf="errorPlacement === 'right'"
          [ngTemplateOutlet]="errorContent"
        ></ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #errorContent>
  <label
    *ngIf="formControl.errors && formControl.touched"
    class="flex-item carm-error-label"
  >
    <span class="label label-danger carm-label-error">
      {{ formControl | errorKey | translate }}
    </span>
  </label>
</ng-template>
